/* global appConfig */
import { createStore  } from 'redux';
import { enhancer } from '@lib/basestore';
import rootReducer from '../../reducers/admin';

export const store = createStore(rootReducer, enhancer);
